
export const RESET_STATE = `RESET_STATE`;
export const resetState = () => ({ type: RESET_STATE });
// export const { RESET_INITIAL_STATE, resetInitialState } = resetState(
//   MODULE_NAME
// );
